export default "__VITE_ASSET__DMhlsAPS__"